import { render, staticRenderFns } from "./GatewayActions.vue?vue&type=template&id=78fd80bf&"
import script from "./GatewayActions.vue?vue&type=script&lang=js&"
export * from "./GatewayActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports